import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { TimeInterval } from '@birco/rainmesh-api';
import { BarChartModule } from '@swimlane/ngx-charts';
import { TranslatePipe } from '@ngx-translate/core';
import { formatStatisticsTooltipDate } from '../../utils/format-statistics-tooltip-date';
import { LocaleService } from '../../../../translation/services/locale.service';
import { LocalizedNumberPipe } from '../../../../shared/pipes/localized-number.pipe';

const DEFAULT_BAR_COLORS = ['#7aa3e5', '#a8385d'];
const OVERLAP_BAR_COLORS = ['#6EA8FE', '#C44569', '#003A8F', '#FF2E63'];

@Component({
  selector: 'app-chart-sensor-data',
  imports: [CommonModule, BarChartModule, TranslatePipe, LocalizedNumberPipe],
  templateUrl: './chart-sensor-data.component.html',
  styleUrl: './chart-sensor-data.component.scss',
})
export class ChartSensorDataComponent {
  private readonly localeService = inject(LocaleService);
  private _sensorData: {
    name: string;
    series: { name: string; timestamp: string; value: number }[];
  }[] = [];

  @Input()
  set overlap(value: boolean) {
    this._overlap = value;
    this.updateCustomColors();
  }

  get overlap(): boolean {
    return this._overlap;
  }

  @Input() interval: TimeInterval | null = null;
  customColors: { name: string; value: string }[] = [];
  private _overlap = false;

  protected legendData: { name: string; color: string }[] = [];

  @Input()
  set sensorData(
    value: {
      name: string;
      series: { name: string; timestamp: string; value: number }[];
    }[],
  ) {
    this._sensorData = value;

    this.updateCustomColors();

    this.legendData = this.customColors.map((color) => ({
      name: color.name,
      color: color.value,
    }));
  }

  private updateCustomColors() {
    const palette = this.overlap ? OVERLAP_BAR_COLORS : DEFAULT_BAR_COLORS;

    this.customColors = (this._sensorData[0]?.series ?? []).map(
      (series, index) => ({
        name: series.name,
        value: palette[index % palette.length],
      }),
    );
  }

  get sensorData(): {
    name: string;
    series: { name: string; timestamp: string; value: number }[];
  }[] {
    return this._sensorData;
  }

  formatTooltipDate(timestamp: string): string {
    return formatStatisticsTooltipDate(
      timestamp,
      this.interval,
      this.localeService.userLanguage,
    );
  }
}
